/* clickable-mobile-nav.js — §48 MOBILE PATTERNS R1 (single owner)
   Canon: page-mobile-patterns tabs "Header + navigation" + "No-vehicle
   strip", AS AMENDED (Lucas, session 5):
     (a) SHOP IS A LINK — the drawer is a plain navigation list.
     (b) IMMUTABLE MOBILE HEADER — the bar never changes between drawer
         states; the drawer + scrim occupy only the region BELOW the
         header line; the hamburger swaps to an X in place.
   Extraction: docs/MOBILE-PATTERNS-R1-EXTRACTION-SHEET.md.

   WHY NON-MODAL: dialog.showModal() puts the dialog in the TOP LAYER —
   its ::backdrop would paint over the header (grey status region, the
   thing the amendment forbids) and everything outside the dialog goes
   INERT, so the header-hosted X could not be tapped. So: dialog.show(),
   an explicit scrim, and explicit Esc / focus-return / behind-inert.

   Owns: drawer open/close (explicit gesture only — rule 20 family), the
   header pin + spacer (zero-shift), and the html vehicle-stamp runtime
   sync (parse-time stamp = the guard's; the strip's visibility rides it). */
(function () {
  if (window.__ckMobileNavInit) return; // run-once (rule 21 corollary)
  window.__ckMobileNavInit = true;

  var dlg = document.querySelector('dialog[data-ck-mnav]');
  var toggle = document.querySelector('[data-ck-mnav-toggle]');
  var scrim = document.querySelector('[data-ck-mnav-scrim]');
  var closeBtn = dlg && dlg.querySelector('[data-ck-mnav-close]');
  if (!dlg || !toggle || !scrim || !closeBtn) return;

  /* ---- html vehicle stamp: runtime sync (parse-time = guard) ---- */
  function verifiedName() {
    try {
      if (window.clickableVehicleState) return window.clickableVehicleState.getName();
      var n = localStorage.getItem('activeVehicleName');
      if (n === null) return null;
      n = n.replace(/"/g, '');
      return (window.clickableVehicleLevel && window.clickableVehicleLevel(n) === 'VERIFIED') ? n : null;
    } catch (e) { return null; }
  }
  function syncStamp() {
    if (verifiedName()) document.documentElement.setAttribute('data-ck-vehicle', 'verified');
    else document.documentElement.removeAttribute('data-ck-vehicle');
  }
  document.addEventListener('clickable:vehicle-changed', syncStamp);
  syncStamp();

  /* ---- AMENDMENT-2 REVISION (Lucas): the header pin + spacer are RETIRED.
     The drawer now COVERS the header (full-height left panel, the
     mini-cart's mechanism), so there is no bar to hold at the viewport top
     and nothing to compensate in flow. The status area is protected the
     proper way instead — the panel paints its own ground through
     env(safe-area-inset-top) (rule 31), in CSS, with no measuring. ---- */

  /* ---- Behind-inert: everything except the scrim and the drawer stops
     taking focus/pointer while open (what showModal would have given us
     for free). The header is NO LONGER excepted — it is covered now, so
     it goes inert with the rest of the page. Reversible by exactly the
     elements we marked — never a blanket sweep on close. ---- */
  var inerted = [];
  function mark(el) {
    if (!el || el.inert) return;
    el.inert = true;
    inerted.push(el);
  }
  function setBehindInert(on) {
    if (on) {
      if (!('inert' in HTMLElement.prototype)) return;
      [].forEach.call(document.body.children, function (el) {
        if (el === scrim || el === dlg || el.contains(dlg)) return;
        mark(el);
      });
      // The drawer's markup is a SIBLING of the header inside the header
      // section, so the body-level sweep has to skip that whole subtree to
      // keep the dialog live — which would leave the HEADER reachable by
      // keyboard behind the scrim. Pointer-wise it is already covered
      // (scrim z-60 over a z-auto header, hit-tested), but Tab does not
      // care about paint order. Inert the header itself, explicitly.
      var header = document.querySelector('[data-ck-header]');
      if (header && !header.contains(dlg)) mark(header);
    } else {
      inerted.forEach(function (el) { el.inert = false; });
      inerted = [];
    }
  }

  /* ---- Focus containment fallback (browsers without inert): cycle Tab
     within the drawer. The toggle is no longer part of the cycle — it is
     covered by the panel, and the drawer's own X is the close control. ---- */
  function focusables() {
    var list = [];
    [].forEach.call(dlg.querySelectorAll('a[href], button:not([disabled])'), function (el) {
      if (el.offsetWidth > 0 || el.offsetHeight > 0) list.push(el);
    });
    return list;
  }
  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key !== 'Tab' || ('inert' in HTMLElement.prototype)) return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* EXIT SYNC (Lucas): the scrim used to be an instant `hidden` toggle while
     the panel animated — two clocks, and the dim outlived the panel. Both
     now run ONE duration and easing (--motion-overlay / --ease-out, in
     clickable-mobile-nav.css). dialog.close() destroys the frame at once,
     so the close is DEFERRED by that duration. Reduced motion collapses the
     wait to 0 so panel and scrim skip TOGETHER rather than one of each. */
  function exitMs() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
    var v = parseFloat(getComputedStyle(document.documentElement)
              .getPropertyValue('--motion-overlay'));
    return isNaN(v) ? 250 : v;
  }
  var closingTimer = null;

  /* ---- Open / close (explicit gesture only) ---- */
  /* R4b BROWSE MODE: the drawer is ONE component with two triggers —
     the hamburger opens it in nav mode, the collection Browse chip
     mounts the category tree and opens it in browse mode (data-mode
     switches the panel's content in CSS). */
  var browseHost = dlg && dlg.querySelector('[data-ck-mnav-browse-host]');
  var browseReturnTo = null;
  var browseOpts = null;

  function openDrawer(focusEl) {
    if (closingTimer) { clearTimeout(closingTimer); closingTimer = null; }
    dlg.classList.remove('is-closing');
    document.body.classList.add('ck-mnav-open');
    scrim.hidden = false;
    // one tick so the opacity transition has a 0 to start from (rAF is not
    // usable here — it never fires in a hidden pane; see the register)
    setTimeout(function () { scrim.classList.add('is-open'); }, 0);
    dlg.show(); // NON-MODAL by design — see the header comment
    toggle.setAttribute('aria-expanded', 'true');
    setBehindInert(true);
    document.addEventListener('keydown', onKeydown);
    // Nav mode: the drawer's own X is the first stop (the hamburger's
    // seat). Browse mode passes its heading instead (R3f focus order —
    // tabindex=-1, the family rule paints nothing).
    (focusEl || closeBtn).focus({ preventScroll: true });
    var panel = dlg.querySelector('.ck-mnav__panel');
    if (panel) panel.scrollTop = 0;
    dlg.scrollTop = 0;
  }
  function closeDrawer() {
    setBehindInert(false);
    document.removeEventListener('keydown', onKeydown);
    var wasBrowse = dlg.getAttribute('data-mode') === 'browse';
    // Start both halves on the same frame, then close after one duration.
    var ms = exitMs();
    scrim.classList.remove('is-open');
    dlg.classList.add('is-closing');
    if (closingTimer) clearTimeout(closingTimer);
    closingTimer = setTimeout(function () {
      closingTimer = null;
      dlg.classList.remove('is-closing');
      dlg.close();
      scrim.hidden = true;
      // Browse-mode teardown AFTER the exit frame (mode swap mid-slide
      // would flash the nav list): content returns to its hidden home.
      if (wasBrowse) {
        dlg.removeAttribute('data-mode');
        var home = document.querySelector('[data-ck-browse-home]');
        var content = browseHost && browseHost.firstElementChild;
        if (home && content) home.appendChild(content);
        if (browseHost) browseHost.hidden = true;
      }
    }, ms);
    document.body.classList.remove('ck-mnav-open');
    toggle.setAttribute('aria-expanded', 'false');
    if (wasBrowse) {
      if (browseOpts && browseOpts.onClose) browseOpts.onClose();
      // Focus returns to the OPENER — the Browse chip, not the hamburger.
      var rt = browseReturnTo;
      if (rt && rt.focus && (document.activeElement === document.body || dlg.contains(document.activeElement))) {
        rt.focus({ preventScroll: true });
      }
      browseReturnTo = null;
      browseOpts = null;
    } else if (document.activeElement === document.body || dlg.contains(document.activeElement)) {
      // Focus returns to the toggle: it never moved, it was merely covered.
      toggle.focus({ preventScroll: true });
    }
  }

  /* Public seam for the collection template's Browse chip. */
  window.ckMnavBrowse = {
    isOpen: function () { return isOpen() && dlg.getAttribute('data-mode') === 'browse'; },
    open: function (contentEl, opts) {
      if (!dlg || !browseHost || !contentEl) return false;
      if (isOpen()) return false; /* never stack modes */
      browseOpts = opts || {};
      browseReturnTo = browseOpts.returnTo || null;
      browseHost.appendChild(contentEl);
      browseHost.hidden = false;
      dlg.setAttribute('data-mode', 'browse');
      var title = contentEl.querySelector('[data-browse-title]');
      openDrawer(title || null);
      if (browseOpts.onOpen) browseOpts.onOpen();
      return true;
    },
    close: closeDrawer
  };
  function isOpen() { return dlg.hasAttribute('open') && !dlg.classList.contains('is-closing'); }

  toggle.addEventListener('click', function () {
    if (isOpen()) closeDrawer(); else openDrawer();
  });
  closeBtn.addEventListener('click', closeDrawer);
  scrim.addEventListener('click', closeDrawer);
  dlg.addEventListener('close', function () {
    // UA/other close paths (form method=dialog, programmatic .close())
    if (document.body.classList.contains('ck-mnav-open')) closeDrawer();
  });

  // (R2b: the drawer's search row is gone with the live-parity rebuild —
  // live carries no search row. Its hand-off handler went with it.)
  // (R2b revisions: the header click-through guard is retired too — the
  // header is covered by the panel and inert behind the scrim, so no
  // header control can be reached while the drawer is open.)
})();
